import { gql } from "@apollo/client";

const updateQuery = gql`
mutation UpdateECCards($qr_code: String = "", $user_id: bigint = "") {
  update_ec_cards(where: {id: {}, qr_code: {_eq: $qr_code}}, _set: {user_id: $user_id}) {
    affected_rows
  }
}
`

export const UpdateECCards = async (
    data,
    client,
) => {
    try {
        // const loginId = JSON.parse(localStorage.getItem('gogo_current_user')).id
        // const merchantId = JSON.parse(localStorage.getItem('gogo_current_user')).merchant_id

        const resp = await client.mutate({
            mutation: updateQuery,
            // refetchQueries: [getQuery],
            variables: {
                "qr_code": data.qr_code,
                "user_id": data?.user_id
            },
            context: {
                headers: {
                    "Content-Type": "application/json",
                    //   "x-hasura-admin-secret": "aseraadmin@1234",
                    'Authorization': `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoic3VwZXJhZG1pbiIsImlhdCI6MTcwMzkyMDQ4MCwiaHR0cHM6Ly9oYXN1cmEuaW8vand0L2NsYWltcyI6eyJ4LWhhc3VyYS1hbGxvd2VkLXJvbGVzIjpbInN1cGVyYWRtaW4iLCJtZXJjaGFudCJdLCJ4LWhhc3VyYS1kZWZhdWx0LXJvbGUiOiJzdXBlcmFkbWluIiwieC1oYXN1cmEtdXNlci1pZCI6IjEiLCJ4LWhhc3VyYS1tZXJjaGFudC1pZCI6IjEwNjAifX0.GmEImnsHm9zxXj2TVNsswvSA3HICCQHuYJiMtPCVZRY`
                },
            },
        });
        if (resp.errors) {
            return { success: false }
        }
        // window.location.reload();
    } catch (e) {
        console.log(JSON.stringify(e));
        // showFailureAlert('Something went wrong while updating your cart');
    }
    return { success: true }
};